// Evaluates user intents and bridges the All-Access-Hub Harness data into Context Prompts

import { injectAllAccessHubContext, getAvailableTopicsForAVI } from '../harness/hub-harness';

/**
 * Primary Context Controller for All-Access-Hub.
 * Evaluates the user's prompt for news intents (Trending, Briefing, Direct Topic)
 * and orchestrates the Harness to fetch the required RSS feeds.
 */
export async function buildAllAccessHubContext(textPrompt: string): Promise<string> {
    // Note: Intent classification is highly complex for news routing and is currently 
    // tightly coupled with the caching engine in the Harness layer. 
    // This wrapper acts as the formal Context Controller interface.
    return await injectAllAccessHubContext(textPrompt);
}

/**
 * Returns the topic discovery block for the AI.
 */
export function buildTopicDiscoveryContext(): string {
    return getAvailableTopicsForAVI();
}
